import React from 'react'
import makeStyles from '@material-ui/core/styles/makeStyles'
import {AddIconButton, reExportedColors, DeleteIconButton, InitialAvatar, Text} from '../../1elements'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import CallIcon from '@mui/icons-material/Call'
import EmailIcon from '@mui/icons-material/Email'

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        borderRight: `1px solid ${reExportedColors.DARK_GREY}`, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        height: '100%'
    },
    contactTypeButton: {
    },
    iconCn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        width: '100%',
        color: reExportedColors.MEDIUM_GREY ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
    },
    accordion: {
        boxShadow: 'none'
    },
    peopleList: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    contactRow: {
        display: 'flex',
        alignItems: 'center',
        maxWidth: '325px',
        padding: '4px',
        borderRadius: '4px'
    },
    contactTypeTitle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: '300px'
    },
    contact: {
        display: 'flex',
        alignItems: 'center'
    },
    contactIcon: {
        color: reExportedColors.DARK_GREY, ////// HARDCODED TO USE CONSTS - to be Assigned a palette color
        height: 11,
        width: 11,
        marginRight: 4
    },
})

const SidePeopleList = (
    {selectedContactList, deletePerson, setSelectedContactType,
        onClickContact, disabled}
) => {
    const classes = useStyles()



    return(
        <div className={classes.root}>
            {
                Object.keys(selectedContactList).map((key, index)=>(
                    <div className={classes.contactTypeButton} key={index}>
                        <div className={classes.contactTypeTitle}>
                            <Text type={'contactTypeName'}>{key}</Text>
                            {!disabled && (
                                <AddIconButton onImportClick={()=>setSelectedContactType(key)} />
                            )}
                        </div>
                        <List className={classes.peopleList}>
                            {
                                selectedContactList[key].map((contact, index)=> (
                                    <ListItem
                                        key={index}
                                        disablePadding
                                        secondaryAction={
                                            !disabled && (
                                                <DeleteIconButton onClick={()=>deletePerson(index, contact.contactType)}
                                                                  fontSize={'small'} disabled={disabled} />
                                            )
                                        }
                                    >
                                        <ListItemButton className={classes.contactRow}
                                                        onClick={()=>onClickContact(contact)}>
                                            <ListItemAvatar>
                                                <InitialAvatar userName={`${contact.firstName} ${contact.lastName}`} email={contact.email} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                secondaryTypographyProps={{component: 'div'}}
                                                primary={
                                                    <Text type='pCName'>{contact.firstName} {contact.lastName}</Text>
                                                }
                                                  secondary={<>
                                                      <div className={classes.contact}>
                                                          <CallIcon className={classes.contactIcon} />
                                                          <Text type='pCDetails'>{contact.phoneNumber}</Text>
                                                      </div>
                                                      <div className={classes.contact}>
                                                          <EmailIcon className={classes.contactIcon} />
                                                          <Text type='pCDetails'>{contact.email}</Text>
                                                      </div>
                                                  </>
                                                } />
                                        </ListItemButton>
                                    </ListItem>
                                ))
                            }
                            {
                                selectedContactList[key].length === 0 && <Text>No Contact</Text>
                            }
                        </List>
                    </div>
                ))
            }
        </div>
    )
}

export default SidePeopleList
